<div *ngIf="activeEnvironment">
    <mras-interview [summaryMode]="summaryMode" [caseId]="mrasData.caseId" [interviewId]="mrasData.interviewId" [pageIndex]="pageIndex" [activeEnvironment]="activeEnvironment"></mras-interview>
</div>